import { ValuationApiClient } from '@einwert/valuation-api-client'
import { getCurrentScope } from '@sentry/react'
import { getBackendRoute } from 'ComponentLibrary/src/common/environment'
import { getAccessToken } from 'ClientPortal/src/services/Auth'
import { getSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'
import { v4 as uuidv4 } from 'uuid'

async function getRequestContext() {
    const token = await getAccessToken()
    const correlationId = uuidv4()
    getCurrentScope().setTag('correlation_id', correlationId)
    const client = new ValuationApiClient({
        baseUrl: getBackendRoute(),
        getToken: async () => token,
        getHeaders: () => ({ 'x-correlation-id': correlationId }),
    })
    return { client, customerId: getSelectedCustomer()?.uuid }
}

export async function getValuation(params: { valuationId: string }) {
    const { client, customerId } = await getRequestContext()
    return client.valuations.getCustomerValuation({ ...params, customerId })
}

export async function getValuations(params: { assetId?: string; includeDrafts?: boolean }) {
    const { client, customerId } = await getRequestContext()
    return client.valuations.getCustomerValuations({ ...params, customerId })
}
